<template>
  <div>
    <div v-if="!error">
      <div class="video-stats-container">
        <div class="video-stats-item" v-for="(card,index) in statsData.bigCard" :key="index">
          <PreLoaderCard :customClass="'card-prefetch-stats'" v-if="isPreLoaderShowing" />
          <div v-if="!isPreLoaderShowing">
            <div class="card card-stats" :class="`card-order-${index}`" v-if="!isLoading">
              <div class="stats-detail">
                <div class="value">{{transformUnit(card.value)}}</div>
                <div class="key">{{card.name}}</div>
              </div>
              <div class="stats-icon">
                <i class="fas fa-play icon"></i>
              </div>
            </div>
            <div v-if="isLoading" class="card card-stats spinner-container">
              <div class="spinner-border" role="status" />
            </div>
          </div>
        </div>
      </div>
      <div class="video-stats-container video-stats-small-container">
        <div class="video-stats-item" v-for="(card,index) in statsData.smallCard" :key="index">
          <PreLoaderCard :customClass="'card-prefetch-small-stats'" v-if="isPreLoaderShowing" />
          <div v-if="!isPreLoaderShowing">
            <div class="card card-stats card-stats-secondary" v-if="!isLoading">
              <div class="stats-icon">
                <i class="fas fa-play icon"></i>
              </div>
              <div class="stats-detail">
                <div class="value">
                  {{transformSmallCardValue(card)}}
                  <span
                    v-if="card.unitName && card.unit !== 'percent'"
                    class="text-unit"
                  >({{card.unitName}})</span>
                </div>
                <div class="key">{{card.name}}</div>
              </div>
            </div>
            <div v-if="isLoading" class="spinner-container">
              <div class="spinner-border" role="status" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <EmptyMessage class="empty-small" v-if="error">
      <h4 slot="title" class="title">พบข้อผิดพลาดระหว่างโหลดสถิติการเล่นวิดีโอ :(</h4>
      <p>
        โปรดรอสักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
        <a
          href="mailto:support@byteark.com"
        >support@byteark.com</a>
      </p>
      <span slot="code" class="code">error code : {{error.status || 'not found' }}</span>
    </EmptyMessage>
  </div>
</template>

<script>
import dateFormatter from '@/utils/dateFormatter';
import numberUtils from '@/utils/numberUtils';
import PreLoaderCard from '@/components/PreLoaderCard.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  mixins: [dateFormatter, numberUtils],
  props: ['error', 'statsData', 'isPreLoaderShowing', 'isLoading'],
  components: {
    PreLoaderCard,
    EmptyMessage,
  },
  methods: {
    transformSmallCardValue(card) {
      switch (card.unit) {
        case 'percent':
          return `${card.value.toFixed(2)} %`;
        case 'min':
          return card.value;
        case 'any':
          return this.transformUnit(card.value);
        default:
          return 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/card.scss';

.video-stats-container {
  display: flex;
  flex-direction: row;

  .video-stats-item {
    flex: 1;
    margin-right: $spacer;

    &:last-child {
      margin-right: 0;
    }
  }
}

.video-stats-container {
  .video-stats-item {
    .spinner-container {
      height: 115px;
    }
  }
}

.video-stats-small-container {
  .video-stats-item {
    .spinner-container {
      padding-top: $spacer;
      height: 70px;
    }
  }
}

@media (max-width: 575.98px) {
  .video-meta-container {
    margin-bottom: $spacer;
  }

  .video-stats-small-container {
    padding: $spacer * 0.5 0;
    flex-wrap: wrap;

    .video-stats-item {
      flex: 0 0 50%;
      margin-right: 0;
    }
  }

  .video-stats-container {
    .video-stats-item {
      .spinner-container {
        height: 80px;
      }
    }
  }

  .video-stats-container:not(.video-stats-small-container) {
    flex-direction: column;

    .video-stats-item {
      margin-right: 0;
      margin-bottom: $spacer * 0.5;
    }
  }
}
</style>
